/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Document, Report } from 'src/app/model';
import { DocumentActionType } from 'src/app/model/document';
import { DocumentProvider } from 'src/app/providers';
import { LogService } from 'src/app/services';

@Component({
  selector: 'documents-action-modal',
  templateUrl: './documents-action.modal.html',
  styleUrls: ['./documents-action.modal.scss']
})
export class DocumentsActionModal implements OnInit, OnDestroy {
  subject: Subject<boolean>;
  subscription: any;

  text: string;
  title: string;
  document: Document;
  currentReport: Report;
  isLoading: boolean = false;
  documentAction: DocumentActionType;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private documentProvider: DocumentProvider,
    private logService : LogService

  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  onConfirm(): void {


    switch (this.documentAction) {
      case 'SEND_REMINDER':
        this.isLoading = true;
        this.documentProvider.sendReminder(this.currentReport.ID, this.document.DOCUMENT_ID)
          .subscribe(data => {
            if (data.success) {
              this.bsModalRef.hide();
              this.subject.next(true);
              this.subject.complete();
            }
            this.isLoading = false;
          }, err => {
            this.isLoading = false;
            this.logService.error(err);
          });

        break;
      case 'VOID_DOCUMENET':
        this.isLoading = true;
        this.documentProvider.voidDocument(this.currentReport.ID, this.document.DOCUMENT_ID)
          .subscribe(data => {
            if (data.success) {
              this.bsModalRef.hide();
              this.subject.next(true);
              this.subject.complete();
            }

            this.isLoading = false;
          }, err => {
            this.isLoading = false;
            this.logService.error(err);
          });
        break;

      default:
        break;
    }

  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }
}
